export default {
	created () {
		let that = this;
		if(sessionStorage.vuexState){
			for(var i in JSON.parse(sessionStorage.vuexState)){
				if (that.$store) that.$store.state[i] = JSON.parse(sessionStorage.vuexState)[i]
			}
		}
		window.onunload = function () {
		    sessionStorage.vuexState = JSON.stringify(that.$store.state)
		}
	}
}


// WEBPACK FOOTER //
// ./src/mixin/store.js